"use client";

import { QueryClient } from "@tanstack/react-query";

const QUERY_DEFAULT_OPTIONS = {
  queries: {
    staleTime: 60 * 1000,
    retry: 1,
  },
} as const;

let browserQueryClient: QueryClient | null = null;

function createIshvaramQueryClient() {
  return new QueryClient({
    defaultOptions: QUERY_DEFAULT_OPTIONS,
  });
}

export function getBrowserQueryClient() {
  if (!browserQueryClient) {
    browserQueryClient = createIshvaramQueryClient();
  }
  return browserQueryClient;
}
